<div id="options-div">
    <app-options-button></app-options-button>
<div id="main">
  <app-panel></app-panel>
</div>

  <app-data-button></app-data-button>
</div>
